import { UBQ } from '../types';
export default {
  type: UBQ,
  service: 'ubiqscan',
  url: 'https://pyrus2.ubiqscan.io',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
